import { Box } from '@mui/material';
import React from 'react';
import { EmailClient } from '../../components/email-system/EmailClient';
import { useParams } from 'react-router-dom';

const EMails = () => {
  const { id } = useParams();
  return (
    <Box className="md:pt-[43px] h-full w-full flex flex-col">
      <EmailClient emailId={id} />
    </Box>
  );
};

export default EMails;
